import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import {
  broadcastUpdatedProtocolSection,
  broadcastUpdatedProtocolSectionError,
} from 'serviceWorker/broadcasts/inspections';
import { upsertProtocolSectionComment } from 'serviceWorker/db/inspections/inspections';
import { neverReached } from 'shared/utils/neverReached';
import { scopeOfQueuedRequest } from 'serviceWorker/helpers/dataScope';

export async function broadcastProtocolSectionResponse(
  request: HttpRequestEntity,
  response: any
): Promise<void> {
  if (response.error) {
    return broadcastUpdatedProtocolSectionError(
      response.error,
      request.data.uniqueId
    );
  }

  switch (request.method) {
    case 'PUT':
      await scopeOfQueuedRequest(request).write(() =>
        upsertProtocolSectionComment({
          inspectionId: request.data.inspectionId,
          section: {
            _id: response?._id || request.data.sectionId,
            checklistSectionId: response?.checklistSectionId,
            comment: response?.comment,
            modifiedAt: response?.modifiedAt,
            modifiedBy:
              typeof response?.modifiedBy === 'string'
                ? response.modifiedBy
                : response?.modifiedBy?._id,
          },
        })
      );
      return broadcastUpdatedProtocolSection(response, request.data.uniqueId);
    case 'POST':
    case 'DELETE':
    case 'GET':
      return broadcastUpdatedProtocolSectionError(
        new Error(`${request.method} method not supported for protocolSection`),
        request.data.uniqueId
      );
    default:
      neverReached(request.method);
  }
}
